import { render, staticRenderFns } from "./addproduct.vue?vue&type=template&id=59a5758c"
import script from "./addproduct.vue?vue&type=script&lang=js"
export * from "./addproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports